module.exports = __webpack_public_path__ + "static/img/ziyou.abfe7d88.png";